import { useSearchParams } from 'react-router-dom';

export const useProblematicFilesPageQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const problemType =
    searchParams.get('problemType') || 'PII Awaiting Approval';

  const treaties = searchParams.getAll('treaty');

  const setProblemTypeParam = (problemType: string) => {
    searchParams.set('problemType', problemType);
    setSearchParams(searchParams, { replace: true });
  };

  const setTreatyParam = (treaties: string[]) => {
    searchParams.delete('treaty');
    treaties.forEach((x) => searchParams.append('treaty', x));
    setSearchParams(searchParams, { replace: true });
  };

  return {
    params: {
      treaties,
      problemType,
    },
    setProblemTypeParam,
    setTreatyParam,
  };
};
